// Weekly couple challenges. Progress is derived from state.challenges counters (reset weekly).
export const CHALLENGES = [
  { id: "cat2", label: "Coba 2 kategori baru", desc: "Selesaikan kencan di 2 kategori berbeda minggu ini.", target: 2, reward: 150, metric: "categories" },
  { id: "care5", label: "Rawat Mochi 5 kali", desc: "Lakukan 5 aksi merawat Mochi minggu ini.", target: 5, reward: 100, metric: "care" },
  { id: "done3", label: "Selesaikan 3 kencan", desc: "Tuntaskan 3 kencan minggu ini.", target: 3, reward: 250, metric: "completed" },
];

export const challengeProgress = (ch, chDef) => {
  if (!ch) return 0;
  if (chDef.metric === "categories") return (ch.categories || []).length;
  if (chDef.metric === "care") return ch.careCount || 0;
  return ch.completedCount || 0;
};
